// angular
import { CommonModule } from '@angular/common';
import {
  Component,
  effect,
  inject,
  input,
  OnInit,
  output,
} from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
// interfaces
import { ISectionTab } from '@app/core/shared/interfaces/section-tab.interface';

@Component({
  selector: 'pwj-section-tabs',
  standalone: true,
  imports: [CommonModule, TranslateModule, RouterLink],
  templateUrl: './section-tabs.component.html',
  styleUrl: './section-tabs.component.scss',
})
export class SectionTabsComponent implements OnInit {
  public currentFragment!: string | null;
  public currentRoute!: string | null;
  public activeTab!: string;

  // inputs
  tabs = input.required<ISectionTab[]>();
  tabClasses = input<string>();
  translateKey = input<string>();
  isBorderedMode = input<boolean>();
  isNavigationMode = input<boolean>();
  currentTab = input<string>('');
  getFullTabInfo = input<string>('');

  // outputs
  onSelectTab = output<string>();
  onTabInfoChange = output<ISectionTab>();

  // dependencies
  private readonly _activatedRoute = inject(ActivatedRoute);
  private readonly _router = inject(Router);
  constructor() {
    // set current tab for active tab
    effect(() => {
      if (this?.currentTab()) {
        this.activeTab = this.currentTab();
      }
    });

    // set first tab title for active tab if its not defined yet
    effect(() => {
      if (!this.activeTab) {
        this.activeTab = this.tabs()?.[0]?.tabTitle;
      }
    });
  }

  ngOnInit() {
    if (this.isNavigationMode()) {
      this.currentFragment = this._activatedRoute.snapshot.fragment;

      this.currentRoute = this._router.url.split('#')[0];

      this._activatedRoute.fragment.subscribe(fragment => {
        this.currentFragment = fragment;
      });
    }
  }

  // Add this tracking function
  public trackByFn(index: number, tab: ISectionTab): string {
    // If you have a unique ID, use that instead
    return tab.tabTitle || index.toString();
  }

  public selectTab(tab: ISectionTab) {
    this.activeTab = tab.tabTitle;
    this.currentFragment = tab.tabTitle;
    this.onSelectTab.emit(tab.tabTitle);
    this.onTabInfoChange.emit(tab);
  }
}
